import i18n from 'i18next';
import { Platform } from 'react-native';
import { initReactI18next } from 'react-i18next';
import * as en from './locales/en.json';
import * as es from './locales/es.json';
import * as ru from './locales/ru.json';
import * as kk from './locales/kk.json';
import * as af from './locales/af.json';
import * as pt from './locales/pt.json';
import * as fr from './locales/fr.json';
import { NativeModules } from 'react-native';

const SUPPORTED_LANGUAGES = ['en', 'es', 'ru', 'kk', 'af', 'pt', 'fr'];

const normalizeLanguageCode = (lang: string): string => {
  // Extract base language code (e.g., 'ru' from 'ru-RU', 'pt' from 'pt-BR')
  const baseLang = lang.split(/[-_]/)[0].toLowerCase();
  
  // Map to supported language if it exists, otherwise return 'en' as fallback
  if (SUPPORTED_LANGUAGES.includes(baseLang)) {
    return baseLang;
  }
  
  return 'en';
};

const getDeviceLanguage = () => {
  let deviceLang = 'en';
  
  if (Platform.OS === 'android') {
    deviceLang = NativeModules['I18nManager']?.localeIdentifier || 'en';
  } else if (Platform.OS === 'ios') {
    deviceLang = (
      NativeModules['SettingsManager']?.settings?.AppleLocale ||
      NativeModules['SettingsManager']?.settings?.AppleLanguages[0] ||
      'en'
    );
  } else {
    deviceLang = navigator?.language || navigator?.languages[0] || 'en';
  }
  
  return normalizeLanguageCode(deviceLang);
};

i18n.use(initReactI18next).init({
  compatibilityJSON: 'v3',
  debug: true,
  resources: {
    en: { translation: en },
    es: { translation: es },
    ru: { translation: ru },
    kk: { translation: kk },
    af: { translation: af },
    pt: { translation: pt },
    fr: { translation: fr },
  },
  lng: getDeviceLanguage(),
  fallbackLng: 'en',
  interpolation: {
    // Disable i18next's default HTML-escaping. Translated strings are rendered
    // only through JSX text nodes / RN <Text>, which escape their own output, so
    // i18next's escaping is a redundant second layer that only corrupts values —
    // e.g. an apostrophe in a title becomes "&#39;" in a toast. Caveat: this
    // removes the implicit backstop, so any future raw-HTML sink
    // (dangerouslySetInnerHTML, innerHTML) must sanitize at the call site.
    escapeValue: false,
  },
});

export default i18n;

export const changeLanguage = async (language: string) => {
  const newLanguageCode = normalizeLanguageCode(language);
  const actualLanguageCode = normalizeLanguageCode(i18n.language);

  if (actualLanguageCode !== newLanguageCode) {
    i18n.changeLanguage(newLanguageCode);
  }
};
